import { DottedSeparator } from "@/components/ui-kit/Decorations/DottedSeparator";
import Image from "next/image";
import { PostAudioPlayerProps } from "@/types/modules/post/components";
import { useAudioPlayer } from "@/hooks/useAudioPlayer";
import { useEffect, useState } from "react";
import { formatTimeToMinutes } from "@/core/utils/formatTime";
import { useOfflinePostContent } from "@/hooks/indexeddb/useOfflinePostContent";

export const PostAudioPlayer: React.FC<PostAudioPlayerProps> = ({ post }) => {
  const { setTrack, play, pause, currentTrack, isPaused } = useAudioPlayer();
  const { offlinePostThumbnail } = useOfflinePostContent();
  const [offlineThumbnailBlob, setOfflineThumbnailBlob] = useState<string>();
  const isPlaying = currentTrack?.id === post.id;

  useEffect(() => {
    if (post && post.audio) {
      offlinePostThumbnail(post).then((res) => {
        setOfflineThumbnailBlob(res);
      });
    }
  }, [post, offlinePostThumbnail]);

  return (
    <>
      <div className="flex w-full items-center justify-between py-5">
        <div className="flex items-center">
          <Image
            src={offlineThumbnailBlob ?? post?.thumbnail["full"]?.url}
            className="mr-[16px] h-[48px] w-[48px] rounded-sm object-cover md:h-[60px] md:w-[60px]"
            width={60}
            height={60}
            placeholder="blur"
            blurDataURL={post?.thumbnail["full"]?.url}
            alt="Post Image"
          />
          <div className="flex max-w-[200px] flex-col sm:max-w-[350px] md:max-w-[450px] lg:max-w-[550px]">
            <p className="mb-[4px] truncate font-sans text-xs font-light text-dark-70 dark:text-white-70 md:text-md">
              {post.title}
            </p>
            <div className="flex">
              <div className="my-auto">
                <Image
                  src="/assets/images/icons/headphones.svg"
                  className="mr-1.5 dark:invert"
                  width={12}
                  height={10}
                  alt="Play icon"
                />
              </div>
              <span className="font-sans text-md dark:text-white md:text-lg">
                {formatTimeToMinutes(post.audio?.length || 0)}
              </span>
            </div>
          </div>
        </div>
        {isPlaying && !isPaused ? (
          <button
            className="flex h-[48px] w-[48px] items-center justify-center rounded-full bg-orange"
            onClick={async () => {
              return pause(post.id);
            }}
          >
            <Image src="/assets/images/icons/pause-ico.svg" width={20} height={20} alt={post.title} />
          </button>
        ) : (
          <button
            className="flex h-[48px] w-[48px] items-center justify-center rounded-full bg-orange"
            onClick={async () => {
              await setTrack(post);
              return;
            }}
          >
            <Image src="/assets/images/icons/play-ico.svg" width={20} height={20} alt={post.title} />
          </button>
        )}
      </div>
      <DottedSeparator />
    </>
  );
};
